export default __webpack_public_path__ + "static/19-aadede3074bcf6e1b22a44caef3ad7c2.webp";